"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObjectEmpty;

var _isObject = _interopRequireDefault(require("./isObject"));

function isObjectEmpty(obj) {
  // https://stackoverflow.com/a/32108184/3135248
  return (0, _isObject.default)(obj) && Object.entries(obj).length === 0 && Object.getOwnPropertyNames(obj).length === 0 && obj.constructor === Object;
}